'use client';

import React from 'react';
import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';
import { FOOTER_PAGE } from '@/common/constant';

const FooterLink = ({ locale }) => {
    const { memberUrl } = useSelector(urlState);

    return (
        <div
            className="flex items-center text-h6 text-white gap-x-[20px]
            ulg:flex-col ulg:w-full ulg:gap-y-[20px] [&_a]:ulg:w-[89px] uxs:!flex-row [&_a]:uxs:!w-full uxs:!gap-x-0"
        >
            <div className="flex flex-grow items-center gap-x-[25px] ulg:w-full ulg:justify-between usx:gap-x-[10px] uxs:flex-col uxs:gap-y-[22px]">
                {FOOTER_PAGE.slice(0, 3).map((v, i) => (
                    <React.Fragment key={v.title + i}>
                        <a
                            href={memberUrl + v.link}
                            target="_blank"
                            rel="noreferrer noopener"
                            className={`gtm-footer-link-${v.gtm} ${
                                i === 1 ? 'ulg:text-center' : ''
                            } ${
                                i === 2 ? 'ulg:text-right' : ''
                            } trans hover:opacity-[.7] uxs:!text-center`}
                        >
                            {locale === 'tw' ? v.title : v.titleCn}
                        </a>
                        <span
                            className={`h-[16px] w-[1px] border-l-1 border-white opacity-[.3] rotate-[40deg] ulg:rotate-0 ${
                                i === 2 ? 'ulg:hidden' : ''
                            } uxs:hidden`}
                        />
                    </React.Fragment>
                ))}
            </div>

            <div className="hidden uxs:flex uxs:flex-col uxs:gap-y-[30px]">
                <span className="w-[1px] h-[15px] border-l-1 border-white border-opacity-[.3]" />
                <span className="w-[1px] h-[15px] border-l-1 border-white border-opacity-[.3]" />
                <span className="w-[1px] h-[15px] border-l-1 border-white border-opacity-[.3]" />
            </div>

            <div className="flex flex-grow items-center gap-x-[25px] ulg:w-full ulg:justify-between usx:gap-x-[10px] uxs:flex-col uxs:gap-y-[22px]">
                {FOOTER_PAGE.slice(3, 6).map((v, i) => (
                    <React.Fragment key={v.title + i}>
                        <a
                            href={i === 0 ? memberUrl + v.link : v.link}
                            target="_blank"
                            rel="noreferrer noopener"
                            className={`gtm-footer-link-${v.gtm} ${
                                i === 1 ? 'ulg:text-center' : ''
                            } ${
                                i === 2 ? 'ulg:text-right' : ''
                            } trans hover:opacity-[.7] uxs:!text-center`}
                        >
                            {locale === 'tw' ? v.title : v.titleCn}
                        </a>
                        {i < 2 && (
                            <span className="h-[16px] w-[1px] border-l-1 border-white opacity-[.3] rotate-[40deg] ulg:rotate-0 uxs:hidden" />
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default FooterLink;
